if (!customElements.get('cm-mobile-menu')) {
  customElements.define('cm-mobile-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.search = this.querySelector('input[type="search"]');
      this.root = this.querySelector('.cm-mobile__root');
      this.results = this.querySelector('.cm-mobile__results');
      this.resultList = this.results.querySelector('ul');
      this.empty = this.results.querySelector('[role="status"]');
      this.drawer = this.closest('header-drawer').querySelector('details');
      this.header = this.closest('.shopify-section');
      this.positionPanel = () => {
        if (this.drawer.open) document.documentElement.style.setProperty('--header-bottom-position', `${Math.max(0, Math.floor(this.header.getBoundingClientRect().bottom))}px`);
      };
      this.headerObserver = new ResizeObserver(this.positionPanel);
      this.headerObserver.observe(this.header);
      this.entries = [...this.querySelectorAll('[data-cm-search-link]')].map(link => ({
        label: link.dataset.cmLabel,
        keywords: link.dataset.cmKeywords || '',
        parent: link.dataset.cmParent || '',
        href: link.getAttribute('href')
      }));
      const currentPath = window.location.pathname.replace(/\/$/, '');
      this.querySelectorAll('[data-cm-search-link]').forEach(link => {
        if (new URL(link.href).pathname.replace(/\/$/, '') === currentPath) link.setAttribute('aria-current', 'page');
      });
      this.search.addEventListener('input', () => this.filter(), options);
      this.search.addEventListener('search', () => this.filter(), options);
      this.closest('header-drawer').querySelector('details').addEventListener('toggle', event => {
        if (event.target.open) requestAnimationFrame(this.positionPanel);
        if (!event.target.open) {
          this.search.value = '';
          this.filter();
          this.querySelector('.cm-mobile__scroll').scrollTop = 0;
        }
      }, options);
    }
    filter() {
      const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
      const query = normalize(this.search.value.trim());
      this.root.hidden = Boolean(query);
      this.results.hidden = !query;
      this.resultList.replaceChildren();
      if (!query) {
        this.empty.hidden = true;
        const drawer = this.closest('header-drawer').querySelector('details');
        if (drawer.open && document.activeElement === this.search && typeof trapFocus === 'function') trapFocus(drawer, this.search);
        return;
      }
      const matches = this.entries.filter(entry => normalize(entry.label + ' ' + entry.parent + ' ' + entry.keywords).includes(query));
      this.empty.hidden = matches.length > 0;
      for (const entry of matches) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = entry.href;
        link.textContent = entry.label;
        if (entry.parent) {
          const group = document.createElement('small');
          group.textContent = entry.parent;
          link.append(group);
        }
        item.append(link);
        this.resultList.append(item);
      }
      if (typeof trapFocus === 'function') trapFocus(this.closest('header-drawer').querySelector('details'), this.search);
    }
    disconnectedCallback() {
      this.headerObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
